import { gsap } from "gsap";

function initAniBanner(root = document) {
    const banners = root.querySelectorAll(".block-anibanner");

    banners.forEach((banner) => {
        const items = Array.from(banner.querySelectorAll(".block-anibanner__item"));
        if (items.length === 0) return;

        if (banner.__aniTimeline) {
            banner.__aniTimeline.kill();
            banner.__aniTimeline = null;
        }

        gsap.set(items, { autoAlpha: 0, scale: 1, filter: "blur(0px)", transformOrigin: "50% 50%" });
        gsap.set(items[0], { autoAlpha: 1, scale: 1, filter: "blur(0px)" });

        const tl = gsap.timeline({ repeat: -1, defaults: { ease: "power2.out" } });

        items.forEach((item, index) => {
            const nextItem = items[(index + 1) % items.length];

            tl.to(item, { duration: 0.8, autoAlpha: 1, scale: 1, filter: "blur(0px)", ease: "power2.out" }, ">")
                .to(item, { duration: 1.4, autoAlpha: 0, scale: 1.18, filter: "blur(8px)", ease: "power2.inOut" }, "+=1.1")
                .fromTo(
                    nextItem,
                    { autoAlpha: 0, scale: 0.95, filter: "blur(6px)" },
                    { duration: 1.2, autoAlpha: 1, scale: 1, filter: "blur(0px)", ease: "power2.out" },
                    "+=0.2"
                );
        });

        banner.__aniTimeline = tl;
    });
}

export { initAniBanner };
